<template>
	<div>
		<h1>개인정보처리방침</h1>
		<br />
		<p>
			진담(이하 "회사"라 한다)은 회사가 제공하는 서비스에 있어 개인정보보호법에 따라 이용자의 개인정보 보호 및 권익을 보호하고 개인정보와 관련한 이용자의 고충을
			원활하게 처리할 수 있도록 『정보통신망 이용촉진 및 정보보호 등에 관한 법률』등 개인정보와 관련된 법령 상의 개인정보보호규정을 준수하여 다음과 같은
			처리방침을 두고 있습니다.
		</p>
		<p>
			※ 회사는 개인정보처리방침을 개정하는 경우 웹사이트 공지사항을 통하여 공지하며, 개별적인 통지를 위하여 회원정보로 등록된 전자우편으로 개정 사항을
			발송드립니다.
		</p>

		<!-- 1. 목적 -->
		<section>
			<h2>1. 목적</h2>
			<p>
				회사는 개인정보를 다음의 목적을 위해 처리합니다. 처리한 개인정보는 다음의 목적이외의 용도로는 사용되지 않으며 이용 목적이 변경될 시에는 사전동의를 구할
				예정입니다.
			</p>
			<p><strong>① 회원가입 및 관리</strong></p>
			<p>
				회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 제한적 본인확인제 시행에 따른 본인확인, 서비스 부정이용 방지, 각종
				고지·통지, 고충처리, 분쟁 조정을 위한 기록 보존 등을 목적으로 개인정보를 처리합니다.
			</p>
			<p><strong>② 민원사무 처리</strong></p>
			<p>민원인의 신원 확인, 민원사항 확인, 사실조사를 위한 연락·통지, 처리결과 통보 등을 목적으로 개인정보를 처리합니다.</p>
			<p><strong>③ 재화 또는 서비스 제공</strong></p>
			<p>서비스 제공, 콘텐츠 제공, 맞춤 서비스 제공, 본인인증, 요금결제·정산 등을 목적으로 개인정보를 처리합니다.</p>
			<p><strong>④ 마케팅 및 광고에의 활용</strong></p>
			<p>
				신규 서비스(제품) 개발 및 맞춤 서비스 제공, 이벤트 및 광고성 정보 제공 및 참여기회 제공, 인구통계학적 특성에 따른 서비스 제공 및 광고 게재, 서비스의
				유효성 확인, 접속빈도 파악 또는 회원의 서비스 이용에 대한 통계 등을 목적으로 개인정보를 처리합니다.
			</p>
			<p><strong>⑤ 개인영상정보</strong></p>
			<p>범죄의 예방 및 수사 등을 목적으로 개인정보를 처리합니다.</p>
		</section>

		<!-- 2. 개인정보 파일 현황 -->
		<section>
			<h2>2. 개인정보 파일 현황</h2>
			<p>회사가 개인정보 보호법 제32조에 따라 등록․공개하는 개인정보파일의 처리목적은 다음과 같습니다.</p>
			<p>① 개인정보 파일명: 진담헤어 회원정보</p>
			<ul>
				<li>
					<p>
						- 개인정보 항목: 이메일, 휴대전화번호, 성별, 생년월일, 이름, 닉네임, 프로필 사진, 서비스 이용 기록, 접속 로그, 쿠키, 접속 IP 정보, 결제기록
					</p>
					<p>- 수집방법: 홈페이지, 모바일 어플리케이션, 모바일 웹페이지, 서면, 팩스, 전화, 고객센터 문의하기, 이벤트 응모</p>
					<p>- 보유근거: 회사의 서비스이용약관 및 개인정보취급방침에 동의</p>
					<p>- 보유기간: 3년</p>
					<p>- 관련법령</p>
					<ul>
						<li><p>- 신용정보의 수집/처리 및 이용 등에 관한 기록: 3년</p></li>
						<li><p>- 소비자의 불만 또는 분쟁처리에 관한 기록: 3년</p></li>
						<li><p>- 대금결제 및 재화 등의 공급에 관한 기록: 5년</p></li>
						<li><p>- 계약 또는 청약철회 등에 관한 기록: 5년</p></li>
						<li><p>- 표시/광고에 관한 기록: 6개월</p></li>
					</ul>
				</li>
			</ul>
			<p>
				※ 기타 회사의 개인정보파일 등록사항 공개는 행정안전부 개인정보보호 종합지원 포털(www.privacy.go.kr) → 개인정보민원 → 개인정보열람등 요구 → 개인정보파일
				목록검색 메뉴를 활용해주시기 바랍니다.
			</p>
		</section>

		<!-- 3. 개인정보의 처리 및 보유 기간 -->
		<section>
			<h2>3. 개인정보의 처리 및 보유 기간</h2>
			<p>
				① 회사는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집시에 동의 받은 개인정보 보유,이용기간 내에서 개인정보를 처리,보유합니다.
			</p>
			<p>② 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.</p>
			<ul>
				<p>- 서비스 회원가입 및 관리와 관련한 개인정보는 수집, 이용에 관한 동의일로부터 3년까지 위 이용목적을 위하여 보유, 이용됩니다.</p>
				<p>- 보유근거: 회사의 서비스이용약관 및 개인정보취급방침에 동의</p>
				<p>- 관련법령</p>
				<ul>
					<li><p>- 신용정보의 수집/처리 및 이용 등에 관한 기록: 3년</p></li>
					<li><p>- 소비자의 불만 또는 분쟁처리에 관한 기록: 3년</p></li>
					<li><p>- 대금결제 및 재화 등의 공급에 관한 기록: 5년</p></li>
					<li><p>- 계약 또는 청약철회 등에 관한 기록: 5년</p></li>
					<li><p>- 표시/광고에 관한 기록: 6개월</p></li>
				</ul>
			</ul>
		</section>

		<!-- 4. 개인정보의 제3자 제공에 관한 사항 -->
		<section>
			<h2>4. 개인정보의 제3자 제공에 관한 사항</h2>
			<p>① 회사는 정보주체의 동의, 법률의 특별한 규정 등 개인정보 보호법 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.</p>
			<p>② 회사는 다음과 같이 개인정보를 제3자에게 제공하고 있습니다.</p>
			<ul>
				<li>
					- 회사는 회원님의 개인정보를 제1조에서 고지한 범위 내에서 사용하며, 회원님의 사전 동의 없이는 동 범위를 초과하여 이용하거나 원칙적으로 이용자의
					개인정보를 제3자에게 제공하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.
				</li>
				<li>
					<ul>
						<li>- 개인정보를 제공받는 자 : [제공받는 자의 정보]</li>
						<li>
							- 제공받는 자의 개인정보 이용목적 : 이메일, 휴대전화번호, 비밀번호, 성별, 생년월일, 이름, 서비스 이용 기록, 접속 로그, 쿠키, 접속 IP 정보,
							결제기록
						</li>
						<li>- 제공받는 자의 보유.이용기간: 3년</li>
					</ul>
				</li>
			</ul>
		</section>

		<!-- 5. 개인정보처리 위탁 -->
		<section>
			<h2>5. 개인정보처리 위탁</h2>
			<p>① 회사는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.</p>
			<ul>
				<li>- 위탁받는 자 (수탁자) : (주)다날, (주)시옷, 나이스정보통신 주식회사, Amazon Web Services, appsflyer</li>
				<li>- 위탁하는 업무의 내용 : 신용카드, 계좌이체, 가상계좌 결제처리, 현금영수증 발행, 모바일 알림서비스, 앱 딥링크, 앱 푸시 발송</li>
				<li>- 위탁기간 : 3년</li>
			</ul>
			<p>
				② 회사는 위탁계약 체결시 개인정보 보호법 제25조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적․관리적 보호조치, 재위탁 제한, 수탁자에 대한
				관리․감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.
			</p>
			<p>③ 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다.</p>
		</section>

		<!-- 6. 타사 웹사이트 또는 자료에 대한 링크의 제공 -->
		<section>
			<h2>6. 타사 웹사이트 또는 자료에 대한 링크의 제공</h2>
			<p>
				회사가 이용자에게 다른 회사의 웹사이트 또는 자료에 대한 링크를 제공하는 경우, 회사는 외부사이트 및 자료에 대한 아무런 통제권이 없으므로 그로부터
				제공받는 서비스나 자료의 유용성에 대해 책임질 수 없으며 보증할 수 없습니다.
			</p>
			<p>
				회사가 포함하고 있는 링크를 클릭(click)하여 타사이트(site)의 페이지로 옮겨 갈 경우 해당 사이트의 개인정보보호정책은 회사와 무관하므로 새로 방문한
				사이트의 정책을 검토해보시기 바랍니다.
			</p>
		</section>

		<!-- 7. 정보주체와 법정대리인의 권리·의무 및 그 행사방법 -->
		<sction>
			<h2>7. 정보주체와 법정대리인의 권리·의무 및 그 행사방법</h2>
			<p>① 정보주체는 회사에 대해 언제든지 개인정보 열람,정정, 삭제, 처리 정지 요구 등의 권리를 행사할 수 있습니다.</p>
			<p>
				② 제1항에 따른 권리 행사는 회사에 대해 개인정보 보호법 시행령 제41조 제1항에 따라 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며 회사는 이에
				대해 지체 없이 조치하겠습니다.
			</p>
			<p>
				③ 제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우 개인정보 보호법 시행규칙 별지 제11호
				서식에 따른 위임장을 제출하셔야 합니다.
			</p>
			<p>④ 개인정보 열람 및 처리정지 요구는 개인정보보호법 제35조 제5항, 제37조 제2항에 의하여 정보주체의 권리가 제한 될 수 있습니다.</p>
			<p>⑤ 개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다.</p>
			<p>
				⑥ 회사는 정보주체 권리에 따른 열람의 요구, 정정·삭제의 요구, 처리정지의 요구 시 열람 등 요구를 한 자가 본인이거나 정당한 대리인인지를 확인합니다.
			</p>
		</sction>

		<!-- 8. 개인정보의 파기 -->
		<section>
			<h2>8. 개인정보의 파기</h2>
			<p>회사는 원칙적으로 개인정보 처리목적이 달성된 경우에는 지체없이 해당 개인정보를 파기합니다. 파기의 절차, 기한 및 방법은 다음과 같습니다.</p>
			<ul>
				<li>
					- 파기절차: 이용자가 입력한 정보는 목적 달성 후 별도의 DB에 옮겨져(종이의 경우 별도의 서류) 내부 방침 및 기타 관련 법령에 따라 일정기간 저장된 후 혹은
					즉시 파기됩니다. 이 때, DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 다른 목적으로 이용되지 않습니다.
				</li>
				<li>
					- 파기기한: 이용자의 개인정보는 개인정보의 보유기간이 경과된 경우에는 보유기간의 종료일로부터 10일 이내에, 개인정보의 처리 목적 달성, 해당 서비스의
					폐지, 사업의 종료 등 그 개인정보가 불필요하게 되었을 때에는 개인정보의 처리가 불필요한 것으로 인정되는 날로부터 10일 이내에 그 개인정보를 파기합니다.
				</li>
				<li>
					- 파기방법: 전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용합니다. 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여
					파기합니다.
				</li>
			</ul>
		</section>

		<!-- 9. 개인정보 자동 수집 장치의 설치•운영 및 거부에 관한 사항 -->
		<section>
			<h2>9. 개인정보 자동 수집 장치의 설치•운영 및 거부에 관한 사항</h2>
			<p>
				회사는 이용자의 정보를 수시로 저장하고 찾아내는 쿠키(cookie) 등을 운용합니다. 쿠키는 웹사이트가 이용자의 컴퓨터 브라우저에 보내는 아주 작은 텍스트
				파일로 이용자의 컴퓨터 하드디스크에 저장됩니다.
			</p>
			<ul>
				<li>
					- 쿠키의 사용 목적: 회원과 비회원의 접속 빈도나 방문 시간 등의 분석, 이용 형태 및 관심분야 파악, 자취 추적, 각종 이벤트 참여 정도, 방문 횟수 파악 등을
					통한 타겟 마케팅 등 개인별 맞춤 서비스를 제공하기 위해 쿠키를 사용 합니다.
				</li>
				<li>
					- 쿠키의 설치, 운영과 거부: 이용자는 쿠키 설치에 대한 선택권을 가지고 있으며, 언제든지 이러한 쿠키의 저장을 거부하거나 삭제할 수 있습니다. 쿠키의
					설정은 웹브라우저별 옵션 선택을 통해 모든 쿠키를 허용, 쿠키가 저장될 때 마다 확인, 모든 쿠키의 저장을 거부 할 수 있습니다. 이러한 쿠키의 설정 방법은
					웹브라우저에 따라 차이가 있으므로, 자세한 사항은 각 브라우저별 도움말을 참고해 주시기 바랍니다. 쿠키의 저장을 거부하였을 경우에는 로그인이 필요한
					서비스 등 일부 서비스 이용에 어려움이 있을 수 있습니다.
				</li>
				<li>
					- 모바일 앱 광고식별자 (ADID): 고객에게 맞춤형 광고를 제공하기 위하여 모바일 앱에서는 광고식별자(ADID)를 수집하여 사용합니다. 회사는 쿠키 및
					광고식별자를 통해 고객의 서비스 사용 이력을 자동으로 수집하고 이를 활용하여 고객 맞춤 광고를 진행합니다. 회사에서 수집하는 쿠키 및 광고식별자는 다른
					개인정보와 연계되지 않으며 개인을 식별하지 않습니다. 사용자는 언제든지 이러한 맞춤형 광고 수신을 거부할 수 있습니다.
				</li>
			</ul>
		</section>

		<!-- 10. 개인정보 보호책임자 작성 -->
		<section>
			<h2>10. 개인정보 보호책임자 작성</h2>
			<p>
				① 회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보
				보호책임자를 지정하고 있습니다.
			</p>
			<ul>
				<li>- 개인정보 보호책임자</li>
				<li>
					<ul>
						<li><p>- 성명: 고건</p></li>
						<li><p>- 직책: 대표</p></li>
						<li><p>- 직급: CEO</p></li>
						<li><p>- 연락처: 010-9285-5128, jindam5128@gmail.com</p></li>
					</ul>
				</li>
				<li><br /></li>
				<li>- 개인정보 보호 담당부서</li>
				<li>
					<ul>
						<li><p>- 부서명: 기획부</p></li>
						<li><p>- 담당자: 고건</p></li>
						<li><p>- 연락처: 010-9285-5128, jindam5128@gmail.com</p></li>
					</ul>
				</li>
			</ul>
			<p>
				② 정보주체께서는 회사의 서비스(또는 사업)을 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및
				담당부서로 문의하실 수 있습니다. 회사는 정보주체의 문의에 대해 지체 없이 답변 및 처리해드릴 것입니다.
			</p>
		</section>

		<!-- 11. 개인정보 처리방침 변경 -->
		<section>
			<h2>11. 개인정보 처리방침 변경</h2>
			<p>
				① 이 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항 및
				전자우편을 통하여 고지할 것입니다.
			</p>
		</section>

		<!-- 12. 개인정보의 안전성 확보조치 -->
		<section>
			<h2>12. 개인정보의 안전성 확보조치</h2>
			<p>회사는 개인정보보호법 제29조에 따라 다음과 같이 안전성 확보에 필요한 기술적/관리적 및 물리적 조치를 하고 있습니다.</p>
			<p><strong>① 개인정보 취급 직원의 최소화 및 교육</strong></p>
			<p>개인정보를 취급하는 직원을 지정하고 담당자에 한정시켜 최소화 하여 개인정보를 관리하는 대책을 시행하고 있습니다.</p>
			<p><strong>② 개인정보의 암호화</strong></p>
			<p>
				이용자의 개인정보는 비밀번호는 암호화 되어 저장 및 관리되고 있어, 본인만이 알 수 있으며 중요한 데이터는 파일 및 전송 데이터를 암호화 하거나 파일 잠금
				기능을 사용하는 등의 별도 보안기능을 사용하고 있습니다.
			</p>
			<p><strong>③ 개인정보에 대한 접근 제한</strong></p>
			<p>
				개인정보를 처리하는 데이터베이스시스템에 대한 접근권한의 부여,변경,말소를 통하여 개인정보에 대한 접근통제를 위하여 필요한 조치를 하고 있으며
				침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있습니다.
			</p>
		</section>

		<br />
		<br />
		<h4>최초시행: 2022.01.01</h4>
	</div>
</template>

<script>
	export default {
		name: 'PrivacyPolicy',
		// 여기에 필요한 데이터, 메소드 등을 정의할 수 있습니다.
	};
</script>

<style scoped>
	h1 {
		font-size: 24px;
	}

	h2 {
		font-size: 20px;
		margin-top: 20px;
	}

	p,
	li {
		font-size: 16px;
		text-indent: 20px;
		list-style: none;
	}

	ul {
		margin-left: 40px;
	}
</style>
